module.exports = {
	"permanent": "Permanent",
	"buttons": {
		"cancel": "Abbrechen",
		"close": "Schließen",
		"copy": "Kopieren",
		"copyFile": "Kopiere Datei",
		"copyToClipboard": "In Zwischenablage kopieren",
		"create": "Neu",
		"delete": "Löschen",
		"download": "Downloaden",
		"info": "Info",
		"more": "mehr",
		"move": "Verschieben",
		"moveFile": "Verschiebe Datei",
		"new": "Neu",
		"next": "nächste",
		"ok": "OK",
		"replace": "Ersetzen",
		"previous": "vorherige",
		"rename": "umbenennen",
		"reportIssue": "Fehler melden",
		"save": "Speichern",
		"search": "Suchen",
		"select": "Auswählen",
		"share": "Teilen",
		"publish": "Veröffentlichen",
		"selectMultiple": "Mehrfachauswahl",
		"schedule": "Planung",
		"switchView": "Ansicht wechseln",
		"toggleSidebar": "Seitenleiste anzeigen",
		"update": "Update",
		"upload": "Upload",
		"permalink": "permanenten Verweis anzeigen"
	},
	"success": {
		"linkCopied": "Verweis wurde kopiert !"
	},
	"errors": {
		"forbidden": "Sie verfügen nicht über die nötigen Rechte!",
		"internal": "Etwas ist schief gelaufen.",
		"notFound": "Dieser Ort kann nicht angezeigt werden."
	},
	"files": {
		"folders": "Ordner",
		"files": "Dateien",
		"body": "Body",
		"clear": "Clear",
		"closePreview": "Vorschau schließen",
		"home": "Home",
		"lastModified": "zuletzt verändert",
		"loading": "Lade...",
		"lonely": "Hier scheint nichts zu sein...",
		"metadata": "Metadaten",
		"multipleSelectionEnabled": "Mehrfachauswahl ausgewählt",
		"name": "Name",
		"size": "Größe",
		"sortByName": "Nach Namen sortieren",
		"sortBySize": "Nach Größe sortieren",
		"sortByLastModified": "Nach Änderungsdatum sortieren"
	},
	"help": {
		"click": "wähle Datei oder Ordner",
		"ctrl": {
			"click": "markiere mehrere Dateien oder Ordner",
			"f": "öffnet eine neue Suche",
			"s": "speichert eine Datei oder einen Ordner am akutellen Ort"
		},
		"del": "löscht die ausgewählten Elemente",
		"doubleClick": "öffnet eine Datei oder einen Ordner",
		"esc": "Auswahl zurücksetzen und/oder Dialog schließen",
		"f1": "diese Informationsseite",
		"f2": "Datei umbenennen",
		"help": "Hilfe"
	},
	"login": {
		"password": "Passwort",
		"submit": "Login",
		"username": "Benutzername",
		"wrongCredentials": "Falsche Zugangsdaten"
	},
	"prompts": {
		"copy": "Kopieren",
		"copyMessage": "Wählen Sie einen Zielort zum Kopieren:",
		"currentlyNavigating": "Aktueller Ort:",
		"deleteMessageMultiple": "Sind Sie sicher, dass Sie {count} Datei(en) löschen möchten?",
		"deleteMessageSingle": "Sind Sie sicher, dass Sie diesen Ordner/diese Datei löschen möchten?",
		"deleteTitle": "Lösche Dateien",
		"displayName": "Display Name:",
		"download": "Lade Dateien",
		"downloadMessage": "Wählen Sie ein Format zum downloaden aus.",
		"error": "Etwas ist schief gelaufen",
		"fileInfo": "Dateiinformation",
		"filesSelected": "{count} Dateien ausgewählt.",
		"lastModified": "Zuletzt geändert",
		"move": "Verschieben",
		"moveMessage": "Choose new house for your file(s)/folder(s):",
		"newDir": "Neuer Ordner",
		"newDirMessage": "Geben Sie den Namen des neuen Ordners an.",
		"newFile": "Neue Datei",
		"newFileMessage": "Geben Sie den Namen der neuen Datei an.",
		"numberDirs": "Anzahl der Ordner",
		"numberFiles": "Anzahl der Dateien",
		"replace": "Ersetzen",
		"replaceMessage": "Eine der Datei mit dem gleichen Namen, wie die Sie hochladen wollen,  existiert bereits. Soll die vorhandene Datei ersetzt werden ?\n",
		"rename": "Umbenennen",
		"renameMessage": "Fügen Sie einen Namen ein für",
		"show": "Anzeigen",
		"size": "Größe",
		"schedule": "Plan",
		"scheduleMessage": "Wählen Sie ein Datum und eine Zeit für die Veröffentlichung dieses Beitrags.",
		"newArchetype": "Erstelle neuen Beitrag auf dem Archetyp. Ihre Datei wird im Inhalteordner erstellt."
	},
	"settings": {
		"admin": "Admin",
		"administrator": "Administrator",
		"allowCommands": "Befehle ausführen",
		"allowEdit": "Bearbeiten, Umbenennen und Löschen von Dateien oder Ordnern",
		"allowNew": "Erstellen neuer Dateien und Ordner",
		"allowPublish": "Veröffentlichen von neuen Beiträgen und Seiten",
		"avoidChanges": "(leer lassen um Änderungen zu vermeiden)",
		"changePassword": "Ändere das Passwort",
		"commands": "Befehle",
		"commandsHelp": "Hier können Befehle benannt werden, die bei Ereignissen ausgeführt werden. Man schreibt einen Befehl pro Zeile. Wenn ein Befehl einen Dateinamen benötigt, wie vor oder  nach dem Speichern, ist die Umgebungsvariable \"FILE\" mit dem Pfad der Datei verfügbar.\n",
		"commandsUpdated": "Befehle aktualisiert!",
		"customStylesheet": "Individuelles Stylesheet",
		"examples": "Beispiele",
		"globalSettings": "Globale Einstellungen",
		"language": "Sprache",
		"lockPassword": "Verhindere, dass der Benutzer sein Passwort ändert",
		"newPassword": "Ihr neues Passwort.",
		"newPasswordConfirm": "Bestätigen Sie Ihr neues Passwort",
		"newUser": "Neuer Benutzer",
		"password": "Passwort",
		"passwordUpdated": "Passwort aktualisiert!",
		"permissions": "Berechtigungen",
		"permissionsHelp": "Sie können einem Benutzer Administratorrechte einräumen oder die Berechtigunen individuell festlegen.  Wenn Sie \"Administrator\" auswählen, werden alle anderen Rechte automatisch vergeben. Die Nutzerverwaltung kann nur durch einen Administrator erfolgen.\n",
		"profileSettings": "Profileinstellungen",
		"ruleExample1": "Verhindert den Zugang zu dot Dateien (dot Files, wie .git, .gitignore) in allen Ordnern\n",
		"ruleExample2": "blockiert den Zugang auf Dateien mit dem Namen Caddyfile in der Wurzel/Basis des scopes.",
		"rules": "Regeln",
		"rulesHelp1": "Hier können Sie erlaubte und verbotene Aktionen für einen einzelnen Benutzer festlegen. Bockierte Dateien werden nicht im Listing angezeigt und sind nicht erreichbar für den Nutzer. Wir unterstützen reguläre Ausdrücke (Regex) und Pfade die relativ zum Benutzerordner sind. \n",
		"rulesHelp2": "Jede Regel hat seine eigene Zeile und beginnt mit dem Schlüsselwort {0} oder {1}. Wenn ein regulärer Ausdruck verwendet wird folgt {2} mit dem Ausdruck oder dem Pfad. \n",
		"scope": "Scope",
		"settingsUpdated": "Einstellungen aktualisiert!",
		"user": "Benutzer",
		"userCommands": "Befehle",
		"userCommandsHelp": "Eine Liste, mit einem Leerzeichen als Trennung, mit den für diesen Nutzer verfügbaren Befehlen. Example:\n",
		"userCreated": "Benutzer angelegt!",
		"userDeleted": "Benutzer gelöscht!",
		"userManagement": "Benutzerverwaltung",
		"username": "Nutzername",
		"users": "Nutzer",
		"userUpdated": "Benutzer aktualisiert!"
	},
	"sidebar": {
		"help": "Hilfe",
		"logout": "Logout",
		"myFiles": "Meine Dateien",
		"newFile": "Neue Datei",
		"newFolder": "Neuer Ordner",
		"settings": "Einstellungen",
		"siteSettings": "Seiteneinstellungen",
		"hugoNew": "Hugo Neu",
		"preview": "Vorschau"
	},
	"search": {
		"images": "Bilder",
		"music": "Musik",
		"pdf": "PDF",
		"pressToExecute": "Drücken Sie Enter zum Ausführen.",
		"pressToSearch": "Drücken Sie Enter zum Suchen.",
		"search": "Suche...",
		"searchOrCommand": "Suche oder führe Befehl aus...",
		"searchOrSupportedCommand": "Suche oder nutze eines Ihrer verfügbaren Befehle:",
		"type": "Tippen und mit Enter bestätigen zum Suchen.",
		"types": "Typen",
		"video": "Video",
		"writeToSearch": "Hier schreiben zum Suchen"
	},
	"languages": {
		"en": "English",
		"fr": "Français",
		"pt": "Português",
		"ja": "日本語",
		"zhCN": "中文 (简体)",
		"zhTW": "中文 (繁體)",
		"es": "Español",
		"de": "Deutsch"
	},
	"time": {
		"unit": "Zeiteinheit",
		"seconds": "Sekunden",
		"minutes": "Minuten",
		"hours": "Stunden",
		"days": "Tage"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/i18n/de.yaml
// module id = 289
// module chunks = 0